import { render, staticRenderFns } from "./factory-alarm-history.vue?vue&type=template&id=2d95966d&scoped=true"
import script from "./factory-alarm-history.vue?vue&type=script&lang=js"
export * from "./factory-alarm-history.vue?vue&type=script&lang=js"
import style0 from "./factory-alarm-history.vue?vue&type=style&index=0&id=2d95966d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95966d",
  null
  
)

export default component.exports